var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "../../interface/IVueDialog";
import LoginService from "../../api/LoginService";
var PasswordSetting = (function (_super) {
    __extends(PasswordSetting, _super);
    function PasswordSetting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginForm = {
            pwd: '',
            conpwd: '',
            name: ''
        };
        return _this;
    }
    PasswordSetting.prototype.created = function () {
        this.service = LoginService.getInstance();
    };
    PasswordSetting.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (res) {
                _this.service.setPwd({
                    password: _this.loginForm.pwd,
                    confirm_pwd: _this.loginForm.conpwd,
                    nickname: _this.loginForm.name
                }).then(function (res) {
                    _this.$closeDialog();
                    _this.$emit("setPassword:ok");
                }, function (error) {
                    _this.$message.error(error.message);
                });
            }
        });
    };
    PasswordSetting = __decorate([
        Component
    ], PasswordSetting);
    return PasswordSetting;
}(IVueDialog));
export default PasswordSetting;
